import { dom } from '@omegagrid/core';
import { AppComponent, Application, ParsedComponentId } from '@reporting/rp-app-host';
import { Sidebar } from './components';

const createMainSidebar = (app: Application, componentId: ParsedComponentId) =>
	dom.createElement<Sidebar>('rp-app-sidebar');

export const componentFactories = new Map<string, (app: Application, componentId: ParsedComponentId) => AppComponent|Promise<AppComponent>>([
	['applications', createMainSidebar]
]);
